<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                Bulk Orders
            </h1>
        </div>
        <div class="bg--gradient-dark">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-5 medium-offset-1">
                    <img src="../../../static/images/bulk-order.png" alt="" />
                </div>
                <div class="cell small-12 medium-6">
                    <h3 class="text-white pad-top text-right">Bulk order</h3>
                    <p class="text-right text-light-blue">Contact us for large enquiries</p>
                    <ul class="bulk-contact-list">
                        <li class="mail">
                            <a class="text-white" href="mailto:sales@customisedclothing.co.uk">Mail</a>
                        </li>
                        <li class="phone">
                            <a class="text-white" href="tel:441164670260">Call</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6">
                <p>
                    <img src="../../../static/images/bulk-order/one.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <h5 class="text-blue pad-top--xxl">Bulk order discounts</h5>
                <p class="marg-bottom--none">
                    For a large volume of promotional printed t-shirts or embroidered work
                    wear please get in contact to discuss further discounts that we can offer.
                    You can benefit from:
                </p>
                <ul>
                    <li class="text-normal">Significant garment and customisation discounts</li>
                    <li class="text-normal">A tailor made approach</li>
                    <li class="text-normal">Free delivery</li>
                </ul>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6">
                <h5 class="text-blue pad-top--xl pad-left--large">Solution oriented service</h5>
                <ol class="pad-left--large">
                    <li>On site consultation</li>
                    <li>Design</li>
                    <li>Bespoke sizing and measurement service</li>
                    <li>Dedicated account management</li>
                    <li>Pre production samples</li>
                    <li>Wearer packs</li>
                    <li>Online order portal</li>
                </ol>
            </div>
            <div class="cell small-12 medium-6">
                <p>
                    <img src="../../../static/images/bulk-order/two.png" alt="" />
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6">
                <p>
                    <img src="../../../static/images/bulk-order/three.jpg" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <h5 class="text-blue pad-top--xl">Large in house capacity and fulfilment</h5>
                <p>
                    Capacity: We have a huge amount of floor space and machinery, which makes no
                    order too big whether it be print or embroidery. We can fulfil bulk orders
                    rapidly  - for current lead times please get in touch<br >Fulfilment: we
                    offer a large range of options such as stock holding, drop shipping,
                    personalised bags and boxes, wearer packs as well as other alternatives.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h5 class="text-center text-blue pad-top--xl pad-bottom--small">What customers say</h5>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl">
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-1.png" alt="" />
                </p>
                <h5 class="text-center">
                    Albert Parker / London
                </h5>
                <p class="text-center pad-left pad-right">
                    The Customised Clothing website was very easy to use, I placed my order online
                    and actually received it a day earlier than expected. Great quality clothing
                    and service! I would highly recommend.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-2.png" alt="" />
                </p>
                <h5 class="text-center">
                    Tom Pollas / Germany
                </h5>
                <p class="text-center pad-left pad-right">
                    I had an urgent requirement for some printed t-shirts for an event, Customised
                    Clothing delivered the t-shirts on time and the quality of print was fantastic.
                    I will definitely be ordering from them again.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'BulkOrder',
    metaInfo() {
        return {
            title: 'Bulk Order',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Bulk order from Customised Clothing' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/bulk-order' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/BulkOrder.vue